// ESTA TABLA ES PARA LA VERSIONES A PARTIR DE LA 1.2.50

import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { connect } from 'react-redux';
import moments from 'moment'
import { formatCurrency } from '../../utils/formatCurrency'
import { Card, CardBody, Badge } from 'reactstrap'
import PlateFormat from '../../components/PlateFormat'
moments.locale('es')

// --- Mobile detection hook ---
const useIsMobile = (breakpoint = 768) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);
    useEffect(() => {
        const handler = () => setIsMobile(window.innerWidth < breakpoint);
        window.addEventListener("resize", handler);
        return () => window.removeEventListener("resize", handler);
    }, [breakpoint]);
    return isMobile;
};

// --- Mobile Card ---
const MobileVehicleCard = ({ item, country }) => (
    <Card className="mb-2 shadow-sm" style={{ borderLeft: "3px solid #8b5cf6", borderRadius: 8 }}>
        <CardBody className="py-2 px-3">
            {/* Row 1: Plate + Value */}
            <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                    <span className="material-symbols-rounded me-2" style={{ fontSize: 18, color: '#8b5cf6' }}>directions_car</span>
                    <span style={{ fontWeight: 700, fontSize: 15 }}>
                        {item.plate ? PlateFormat(item.plate, country) : 'Sin Matrícula'}
                    </span>
                </div>
                <div>
                    <span style={{ fontWeight: 700, fontSize: 14 }}>
                        {formatCurrency(item.custom_value && item.custom_value > 0 ? item.custom_value : item.rate_value)}
                    </span>
                    {item.custom_value > 0 && (
                        <Badge color="success" className="bg-opacity-10 text-success ms-1" style={{ fontSize: 10 }}>T.ESP</Badge>
                    )}
                </div>
            </div>
            {/* Row 2: Brand + Category */}
            <div style={{ marginTop: 4, fontSize: 13, color: '#555' }}>
                {item.brand && <span className="me-2">{item.brand.toUpperCase()}</span>}
                {item.category_name && <span className="text-muted">| {item.category_name.toUpperCase()}</span>}
            </div>
            {/* Row 3: Customer + Location */}
            <div className="d-flex justify-content-between align-items-center" style={{ marginTop: 4 }}>
                <div className="d-flex align-items-center">
                    <span className="material-symbols-rounded text-muted me-1" style={{ fontSize: 14 }}>person</span>
                    <span style={{ fontSize: 13, fontWeight: 600 }}>{item.fullName.toUpperCase()}</span>
                </div>
                {item.floor_name && item.floor_name !== ' - ' && (
                    <span className="text-muted" style={{ fontSize: 12 }}>
                        <span className="material-symbols-rounded me-1" style={{ fontSize: 13 }}>location_on</span>
                        {item.floor_name}
                    </span>
                )}
            </div>
        </CardBody>
    </Card>
);


const TableCCVehicles = (props) => {
    const country = props.currentCompany?.country;
    const isMobile = useIsMobile();

    const columns = [
        {
            name: <span className='font-weight-bold fs-13'>Matrícula</span>,
            selector: row => row.plate || '',
            cell: row => (
                <div className="d-flex align-items-center">
                    <span className="material-symbols-rounded me-2" style={{ fontSize: 16, color: '#8b5cf6' }}>directions_car</span>
                    <span style={{ fontWeight: 700 }}>{row.plate ? PlateFormat(row.plate, country) : 'Sin Matrícula'}</span>
                </div>
            ),
            sortable: true,
            wrap: true,
            width: "180px",
            cellExport: row => row.plate || 'Sin Matrícula',
        },
        {
            name: <span className='font-weight-bold fs-13'>Cliente</span>,
            selector: row => row.fullName,
            cell: row => <span style={{ fontWeight: 600 }}>{row.fullName.toUpperCase()}</span>,
            sortable: true,
            wrap: true,
            grow: 2,
            cellExport: row => row.fullName,
        },
        {
            name: <span className='font-weight-bold fs-13'>Marca/Modelo</span>,
            selector: row => row.brand ? row.brand.toUpperCase() : 'Sin Marca',
            sortable: true,
            wrap: true,
            grow: 1,
            cellExport: row => row.brand ? row.brand.toUpperCase() : 'Sin Marca',
        },
        {
            name: <span className='font-weight-bold fs-13'>Categoría</span>,
            selector: row => row.category_name ? row.category_name.toUpperCase() : 'Sin Categoría',
            sortable: true,
            wrap: true,
            width: "140px",
            cellExport: row => row.category_name ? row.category_name.toUpperCase() : 'Sin Categoría',
        },
        {
            name: <span className='font-weight-bold fs-13'>Ubicación</span>,
            selector: row => row.floor_name || ' - ',
            sortable: true,
            wrap: true,
            width: "150px",
            cellExport: row => row.floor_name || ' - ',
        },
        {
            name: <span className='font-weight-bold fs-13'>Tarifa</span>,
            selector: row => row.timelapse_label,
            sortable: true,
            wrap: true,
            width: "120px",
            cellExport: row => row.timelapse_label,
        },
        {
            name: <span className='font-weight-bold fs-13'>Valor Mensual</span>,
            selector: row => row.custom_value && row.custom_value > 0 ? row.custom_value : row.rate_value,
            cell: row => {
                if (row.custom_value && row.custom_value > 0) {
                    return (
                        <span>
                            <strong>{formatCurrency(row.custom_value)}</strong>
                            <Badge color="success" className="bg-opacity-10 text-success ms-1" style={{ fontSize: 10 }}>T.ESP</Badge>
                        </span>
                    );
                }
                return <strong>{formatCurrency(row.rate_value)}</strong>;
            },
            sortable: true,
            width: "150px",
            right: true,
            cellExport: row => row.custom_value && row.custom_value > 0 ? row.custom_value : row.rate_value
        },
    ];


    if (!props.cc_vehicles) {
        return (<div>No hay vehículos por el momento</div>)
    }

    let items = []
    props.cc_vehicles.forEach((cc) => {
        const item = {
            id: cc['id'],
            plate: cc['plate'],
            brand: cc['brand'],
            category_name: cc['category_name'],
            fullName: cc['fullName'],
            floor_name: cc['place_name'] ? cc['floor_name'] + " - " + cc['place_name'] : ' - ',
            presence: cc['is_present'],
            timelapse_label: cc['timelapse_label'],
            custom_value: cc['custom_value'],
            rate_value: cc['rate_value'],
        }
        items.push(item)
    })

    const data = items

    // --- Mobile view ---
    if (isMobile) {
        return (
            <div>
                <div className="text-muted mb-2" style={{ fontSize: 13, fontWeight: 600 }}>
                    Vehículos ({data.length})
                </div>
                {data.length === 0 ? (
                    <div className="p-4 text-center text-muted">No hay datos</div>
                ) : (
                    data.map((item, index) => (
                        <MobileVehicleCard key={index} item={item} country={country} />
                    ))
                )}
            </div>
        );
    }

    // --- Desktop view ---
    const tableData = {
        columns,
        data
    };

    return (
        <div>
            <DataTableExtensions
                {...tableData}
                exportHeaders={false}
                filterPlaceholder="Filtrar"
            >
                <DataTable
                    title={"Vehículos (" + String(data.length) + ")"}
                    pagination
                    highlightOnHover
                    pointerOnHover
                    paginationPerPage={30}
                    paginationRowsPerPageOptions={[30, 100, 200]}
                    className="data-table"
                    paginationDefaultPage={1}
                    paginationComponentOptions={{
                        rowsPerPageText: "Filas por página:",
                        rangeSeparatorText: "de",
                        noRowsPerPage: false,
                        selectAllRowsItem: false,
                        selectAllRowsItemText: "All",
                    }}
                    noDataComponent={
                        <div className="p-4 text-center">No hay datos</div>
                    }
                    persistTableHead
                />
            </DataTableExtensions>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        cc_vehicles: state.data.cc_vehicles,
        currentCompany: state.companies.currentCompany,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(TableCCVehicles)
